
const digest = 'b272de1d426debd476330e96beed0904d6a6b3e330badf6dbfab2cfb12f241d5';
const classes = {"wrapper":"_wrapper_11z3f_1","item":"_item_11z3f_7","itemLabel":"_itemLabel_11z3f_23"};
const css = `._wrapper_11z3f_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

._item_11z3f_7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f6f9;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 20px;
  border-radius: 10px;
}
._item_11z3f_7:hover {
  cursor: pointer;
  background-color: #eaedf3;
}

._itemLabel_11z3f_23 {
  word-break: break-word;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  